module.exports = __webpack_public_path__ + "static/media/perfect_z.096312db.svg";